import React from 'react';
import axios from 'axios';
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { formatNull, formatDateTime, formatOverflow, isWithinLast15MinutesMoscow, formatBalance } from '../../../Utils/GlobalUtils';

import Modal from '../../Modal';
import SearchTransactions from '../../SearchModals/SearchTransactions';

import Loading from '../../Loading';
import WarningPanel from '../../WarningPanel';
import LoadingLines from '../../LoadingLines';

import headerPanel from '../../../styles/HeaderPanel.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as GavelIcon } from '../../../icons/gavel.svg';
import { ReactComponent as ReloadIcon } from '../../../icons/reload.svg';
import { ReactComponent as CopyIcon } from '../../../icons/copy.svg';

const TransactionsHistory = ({  }) => {
    const navigate = useNavigate();
    const location = useLocation();
    let { userId } = useParams();
    const { openTimeModal } = useTimeModal();

    const [cases, setCases] = React.useState([]);

    const [limitForView, setLimitForView] = React.useState(50);
    const [warning, setWarning] = React.useState('');
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        setLoading(true);

        axios.get(`/api/get-all-balance-transactions?id=${userId}&limitForView=${limitForView}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then((response) => {
            setCases(response.data);
        })
        .catch((error) => {
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
        })
        .finally(() => {
            setReload(false);
            setLoading(false);
        });
    }, [reload, userId]);

    const [confirmDeleteId, setConfirmDeleteId] = React.useState(null);
        
    React.useEffect(() => {
        if (confirmDeleteId !== null) {
        const timeout = setTimeout(() => setConfirmDeleteId(null), 3000);
        return () => clearTimeout(timeout);
        }
    }, [confirmDeleteId]);

    const [isSearch, setIsSearch] = React.useState(false);

    React.useEffect(() => {
        if (window.location.hash === '#search') {
            setIsSearch(true);
        }
    }, []);


  return (
    <>
        <Modal isOpen={isSearch} closeModal={() => { window.location.hash = ''; setIsSearch(false) }} headline={'Поиск транзакций'}>
            <SearchTransactions />
        </Modal>

        <div className={headerPanel.panel}>
            <div className={headerPanel.searchBtn} onClick={() => { window.location.hash = 'search'; setIsSearch(true) }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z" /></svg>
                Поиск...
            </div>
        </div>
        <div className='tableContainer'>
            <div className='tableHeaderWrapper'>
            <div className='tableStatus'>
                <div>
                <h3>История всех транзакций</h3>
                </div>
                <a className='lastUpdateWrapper'>
                    {loading ? 
                        <Loading type='inline' /> 
                    : 
                        <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                    }
                </a>
            </div>
            <div className='tableHeader' style={{ gridTemplateColumns: '10fr 10fr 20fr 20fr 30fr 10fr' }}>
                <div>Сумма</div>
                <div>Действие</div>
                <div>Пользователь</div>
                <div>Инициатор транзакции</div>
                <div>Описание операции</div>
                <div>Дата</div>
            </div>
            </div>
            {(cases.length==0 && loading) ? <LoadingLines />
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
            : cases.map((caseItem) => (
                <div 
                    className='tableRow nonActive' 
                    style={{ gridTemplateColumns: '10fr 10fr 20fr 20fr 30fr 10fr', borderLeft: isWithinLast15MinutesMoscow(caseItem.created_at) ? '2px solid #84abffff' : '' }}
                    key={caseItem.id} 
                >
                    <div>
                        {caseItem.action+formatNull(formatBalance(caseItem.amount)) + ' ₽'}
                    </div>
                    <div>
                        <p
                            className={caseItem.action=='+' ? 'colorCell green' : caseItem.action=='-' ? 'colorCell red' : '' }
                        >
                            {caseItem.action=='+' && 'Пополнение'}
                            {caseItem.action=='-' && 'Списание'}
                        </p>
                        <p className='description'>
                            {caseItem.balance_type=='balance' && 'Членские взносы'}
                            {caseItem.balance_type=='specialBalance' && 'Целевые взносы'}
                        </p>
                    </div>
                    <div>
                        <Link 
                            className='aWithLink' 
                            to={`/account/${caseItem.user_id}`}
                        >
                                {caseItem.userDetails?.lastname} {caseItem.userDetails?.firstname} {caseItem.userDetails?.surname} {caseItem.userDetails?.email}
                        </Link>
                    </div>
                    <div>
                        <Link 
                            className='aWithLink' 
                            to={`/account/${caseItem.initiator_id}`}
                        >
                            {caseItem.initiatorDetails?.lastname} {caseItem.initiatorDetails?.firstname} {caseItem.initiatorDetails?.surname} {caseItem.initiatorDetails?.email}
                        </Link>
                    </div>
                    <div>
                        <p>{formatNull(caseItem.description)}</p>
                        <span className='horizontalLine'></span>
                        <span style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
                        <p className='description'>Идентификатор транзакции: {formatNull(caseItem.transaction_id)}</p>
                        <IconContainer 
                            Icon={CopyIcon} 
                            label={'Скопировать'} 
                            onClick={() => {
                                navigator.clipboard.writeText(caseItem.transaction_id);
                                openTimeModal('Идентификатор скопирован', 'success');
                            }} 
                            size = '15' 
                            color = 'black' 
                            className = '' 
                        />
                        </span>
                    </div>
                    <div>
                        <p
                            className='monoTime'
                        >
                            {formatNull(formatDateTime(caseItem.created_at))}
                        </p>
                    </div>
                </div>
            ))}
            {!warning && cases.length > 0 && (cases.length < cases[0].total_count) && (
                <div className='tableLoadMoreRow' style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                    <div></div>
                    <div>
                        <button
                            type='button'
                            className='button'
                            style={{ width: 'fit-content' }}
                            onClick={() => {setLimitForView(prev => prev + 50); setReload(true)}}
                            disabled={loading}
                        >
                            {loading ? <Loading type='inline' /> : 'Загрузить ещё'}
                        </button>
                    </div>
                    <div></div>
                </div>
            )}
        </div>
    </>
  )
}

export default TransactionsHistory;